export type RemoveItemSource = any;

type TryRemoveFromMailStoreItemsFunction = (
    itemIdToRemove: string,
    removeItemSource: RemoveItemSource,
    skipMutator?: boolean
) => void;

let tryRemoveFromMailStoreItemsFunc: TryRemoveFromMailStoreItemsFunction | null = null;

export function setTryRemoveFromMailStoreItemsFunction(
    func: TryRemoveFromMailStoreItemsFunction
): void {
    tryRemoveFromMailStoreItemsFunc = func;
}

export default function tryRemoveFromMailStoreItems(
    itemIdToRemove: string,
    removeItemSource: RemoveItemSource,
    skipMutator?: boolean
): void {
    if (!tryRemoveFromMailStoreItemsFunc) {
        throw new Error('tryRemoveFromMailStoreItemsFuncNotSet');
    }
    tryRemoveFromMailStoreItemsFunc(itemIdToRemove, removeItemSource, skipMutator);
}
